module.exports = __webpack_public_path__ + "img/website.34f751f5.png";